import { message } from "antd";

export default function Message(text = "Непредвиденная ошибка", status) {
  const renderMessage = () => {
    switch (status) {
      case 200:
        message.success({
          content: text,
          style: {
            marginTop: "15vh",
          },
        });
        break;
      case 204:
        message.success({
          content: text,
          style: {
            marginTop: "15vh",
          },
        });
        break;
      case "warning":
        message.warning({
          content: text,
          style: {
            marginTop: "15vh",
          },
        });
        break;
      default:
        message.error({
          content: text,
          style: {
            marginTop: "15vh",
          },
        });
    }
  };

  return renderMessage();
}
